import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'

const ZariForm = ({ children }) => {
  const submitHandler = React.useCallback(e => {
    e.preventDefault()
  }, [])

  return (
    <Form onSubmit={submitHandler} noValidate autoComplete='off'>
      {children}
    </Form>
  )
}

ZariForm.propTypes = {
  children: PropTypes.any
}

export default React.memo(ZariForm)
